import React from "react";
import "../../../index.css";
import HowImage from "../../../helper/images/How.png";
import SignImage from "../../../helper/svg/Signup.svg";
import Googleplay from "../../../helper/svg/googleplay.svg";
import Appstore from "../../../helper/svg/appstore.svg";
import Manage from "../../../helper/svg/manage.svg";
import Grow from "../../../helper/svg/Grow.svg";
import { Link } from "react-router-dom";
import { useTranslation } from "../../../hooks/useTranslation";
const HowItWorks = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="bg-[#FFF3EF] lg:py-[100px] md:py-[70px] py-[30px]">
        <div className="container">
          <div className="grid xl:grid-cols-[1fr_auto] lg:grid-cols-2 grid-cols-1 gap-[20px] md:gap-[44px] items-center">
            <img src={HowImage} alt="" className="w-full rounded-[10px]" />
            <div className="xl:max-w-[453px]">
              <h2 className="text-[#18181B] lg:text-[40px] md:text-[30px] text-[25px] font-semibold lg:leading-[47px] leading-9 mb-5">
                {t("about").howItWorks.title}
              </h2>
              <div className="grid grid-cols-[59px_1fr] gap-[17px] mt-[51px] w-full mb-[35px]">
                <div className="w-[59px] h-[59px] rounded-[5px] bg-[#4CAF50] flex items-center justify-center">
                  <img src={SignImage} alt="Icon" className="w-[37px]" />
                </div>
                <div className="w-full">
                  <h2 className="md:text-[22px] text-lg  font-semibold leading-[22px] mb-[7px]">
                    {t("about").howItWorks.steps.signup.title}
                  </h2>
                  <p className="text-base leading-[26px] lg:max-w-[347px]">
                    {t("about").howItWorks.steps.signup.description}
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-[59px_1fr] gap-[17px] mt-[51px] w-full mb-[35px]">
                <div className="w-[59px] h-[59px] rounded-[5px] bg-[#4CAF50] flex items-center justify-center">
                  <img src={Manage} alt="Icon" className="w-[37px]" />
                </div>
                <div className="w-full">
                  <h2 className="md:text-[22px] text-lg  font-semibold leading-[22px] mb-[7px]">
                    {t("about").howItWorks.steps.manage.title}
                  </h2>
                  <p className="text-base leading-[26px] lg:max-w-[347px]">
                    {t("about").howItWorks.steps.manage.description}
                  </p>
                </div>
              </div>
              <div className="grid grid-cols-[59px_1fr] gap-[17px] mt-[51px] w-full mb-[35px]">
                <div className="w-[59px] h-[59px] rounded-[5px] bg-[#4CAF50] flex items-center justify-center">
                  <img src={Grow} alt="Icon" className="w-[37px]" />
                </div>
                <div className="w-full">
                  <h2 className="md:text-[22px] text-lg  font-semibold leading-[22px] mb-[7px]">
                    {t("about").howItWorks.steps.grow.title}
                  </h2>
                  <p className="text-base leading-[26px] lg:max-w-[347px]">
                    {t("about").howItWorks.steps.grow.description}
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-[13px] w-full md:mt-[30px] mt-5">
                <Link to="/" className="">
                  <img
                    src={Googleplay}
                    alt="download"
                    className="w-full h-full object-cover"
                  />
                </Link>
                <Link to="/" className="">
                  <img
                    src={Appstore}
                    alt="download"
                    className="w-full h-full object-cover"
                  />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HowItWorks;
